import { Form, Formik } from "formik";
import MembershipHeader from "../../../components/Common/Frontend/Layout/MembershipHeader";
import ApplicationForm from "./ApplicationForm";
import SimpleReactValidator from "simple-react-validator";
import { useRef, useState } from "react";
import { messages } from "./messages";
import {
    Button,
    TabContent,
    TabPane,
} from "reactstrap";
import { initalMemberShipValue } from "./commonFunction";
import AgreementForm from "./AgreementForm";
import Taxpayer from "./Taxpayer";

function MembershipForm(props) {
    const validator = useRef(new SimpleReactValidator());
    const [language, setLanguage] = useState("en");

    const handleLanguageChange = (selected) => {
        setLanguage(selected.value);
        // console.log("Selected Language:", selected.value);
    };
    const selectedLanguage = messages[language];
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const next = () => {
        if (parseInt(activeTab) < 9) {
            setActiveTab((prev) => (parseInt(prev) + 1).toString());
        }
    };

    const previous = () => {
        if (parseInt(activeTab) > 1) {
            setActiveTab((prev) => (parseInt(prev) - 1).toString());
        }
    };

    const tabs = Array.from({ length: 9 }, (_, i) => (i + 1).toString());
    const tabTitles = [
        "Application Form",
        "MEMBERSHIP AGREEMENT",
        "Education",
        "Experience",
        "Skills",
        "Certifications",
        "References",
        "Review",
        "Confirmation",
    ];
    return (
        <div className="main-body front_main">
            <MembershipHeader onChange={handleLanguageChange} value={language} />
            <main className="main-inner">
                <div className="container membership">
                    <Formik initialValues={initalMemberShipValue} onSubmit={() => { }}>
                        {({ values, setFieldValue }) => (
                            <Form className="form-horizontal form-login row">
                                <TabContent activeTab={activeTab}>
                                    {tabs.map((tab) => (
                                        <TabPane tabId={tab} key={tab}>
                                            {tab === "1" && (
                                                <ApplicationForm
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                    validator={validator}
                                                    language={selectedLanguage}
                                                />
                                            )}
                                            {tab === "2" && (
                                                <AgreementForm
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                    validator={validator}
                                                    language={selectedLanguage}
                                                />
                                            )}
                                            {tab === "3" && (
                                                <Taxpayer values={values}
                                                    setFieldValue={setFieldValue}
                                                    validator={validator}
                                                    language={selectedLanguage} />
                                            )}
                                        </TabPane>
                                    ))}
                                </TabContent>
                                <div className="dot-navigation mb-3">
                                    <div className="dot-wrapper">
                                        {tabs.map((tab, index) => {
                                            const isActive = activeTab === tab;
                                            const isPrevious = parseInt(tab) < parseInt(activeTab);
                                            return (
                                                <div
                                                    key={tab}
                                                    className={`dot ${isActive ? "active" : ""}`}
                                                    data-label={isActive ? tabTitles[index] : ""}
                                                    onClick={() => toggle(tab)}
                                                    style={{
                                                        backgroundColor: isActive
                                                            ? "#002e70"
                                                            : isPrevious
                                                                ? "#6c757d"
                                                                : "#ccc",
                                                    }}
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Button
                                        color="secondary"
                                        onClick={previous}
                                        disabled={activeTab === "1"}
                                    >
                                        Previous
                                    </Button>
                                    <Button
                                        color="primary"
                                        onClick={next}
                                        disabled={activeTab === "9"}
                                    >
                                        Next
                                    </Button>
                                </div>


                            </Form>
                        )}
                    </Formik>
                </div>
            </main>
        </div>
    );
}

export default MembershipForm;
